// eslint-disable-next-line import/prefer-default-export
export const BREAKPOINTS = {
  mobile: 550,
  mobileMd: 767,
  tablet: 1024,
  desktop: 1000,
  hd: 1200
};
